const ANNUAL_NOTE = 'Após 12 meses';

export const PLAN_REFERENCE_TIERS = [
  { id: 'plano-1', nome: 'Plano 1', mensal: 1499, anual: 1274.15 },
  { id: 'plano-2', nome: 'Plano 2', mensal: 2999, anual: 2549.15 },
  {
    id: 'avancado',
    nome: 'Avançado',
    mensal: 3949,
    anual: 3356.65,
    destaque: true,
  },
  { id: 'plano-4', nome: 'Plano 4', mensal: 5499, anual: 4674.15 },
  { id: 'plano-5', nome: 'Plano 5', mensal: 9900, anual: 8415 },
  { id: 'plano-6', nome: 'Plano 6', mensal: 12000, anual: 10200 },
];

const DEFAULT_FEATURES = ['Atendimentos', 'Cobrança de atendimento'];

const normalizeNumber = value => {
  if (value === null || value === undefined || value === '') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : value;
};

const firstPresent = (payload, keys) =>
  keys
    .map(key => payload[key])
    .find(value => value !== undefined && value !== null);

const fallbackPlan = (tier, cycle) => ({
  id: cycle === 'anual' ? `${tier.id}-anual` : tier.id,
  nome: tier.nome,
  preco: cycle === 'anual' ? tier.anual : tier.mensal,
  precoLabel: null,
  atendimentos: null,
  atendimentosLabel: 'Atendimentos',
  precoPorAtendimento: null,
  precoPorAtendimentoLabel: null,
  destaque: Boolean(tier.destaque),
  cta: 'escolher',
  features: DEFAULT_FEATURES,
  annualNote: cycle === 'anual' ? ANNUAL_NOTE : null,
});

export const defaultMonthlyPlans = () =>
  PLAN_REFERENCE_TIERS.map(tier => fallbackPlan(tier, 'mensal'));

export const defaultAnnualPlans = () =>
  PLAN_REFERENCE_TIERS.map(tier => fallbackPlan(tier, 'anual'));

export const cycleSuffix = cycle => (cycle === 'anual' ? 'anual' : 'mensal');

export const buildPlanContactMessage = (plan, cycle) => {
  const suffix = cycleSuffix(cycle);
  if (plan?.cta === 'vendas') {
    return `Atendimento comercial sobre o plano ${plan.nome} ${suffix}`;
  }
  return `Gostaria de contratar o plano ${plan.nome} ${suffix}`;
};

export const normalizeCatalogPlan = (plan, cycle) => {
  const payload = plan || {};
  const annual = cycle === 'anual';
  const price = annual
    ? firstPresent(payload, ['mensal_equivalente', 'mensal', 'anual'])
    : payload.mensal;

  return {
    id: payload.id,
    nome: payload.nome,
    preco: normalizeNumber(price),
    precoLabel:
      price === null || price === undefined
        ? payload.preco_label || payload.price_label
        : undefined,
    atendimentos: payload.atendimentos_ciclo,
    atendimentosLabel: payload.atendimentos_label,
    precoPorAtendimento: normalizeNumber(
      payload.preco_por_atendimento ?? payload.price_per_attendance
    ),
    precoPorAtendimentoLabel:
      payload.preco_por_atendimento_label || payload.price_per_attendance_label,
    destaque: Boolean(payload.destaque),
    cta: payload.cta || 'escolher',
    features: Array.isArray(payload.features) ? payload.features : [],
    annualNote: annual
      ? payload.nota_anual || payload.annual_note || ANNUAL_NOTE
      : null,
  };
};

export const usageFromBillingPayload = payload => {
  const usage = payload?.uso || payload?.uso_ciclo || payload?.cycle_usage;
  if (!usage) return null;

  return {
    percentual: usage.percentual,
    atendimentos: usage.consumidos_mes ?? usage.atendimentos,
    limite: usage.cota_mensal ?? usage.limite,
  };
};
